export const WeixinShare = {
    create: function (shareData) {
        window.H.post("/app/wechath5/sign", { "url": window.location.href }, function (res) {
            WeixinShare.config(res, shareData);
        });
    },

    isClose: false,
    config: function (res, shareData) {
        // console.log(shareData.shareName);
        // let userInfo = localStorage.getItem('userInfoH5') ? JSON.parse(localStorage.getItem('userInfoH5')) : {}
        let normalConfig = {
            // shareName: userInfo.nickname + '的分享',// => 名称
            shareImg: window.location.origin + window.location.pathname + 'img/faclogo.jpg', // => logo
            shareMs: '专精特新首席加速器！5年培育期，目标北交所！中小企业做上市的最快通道！',//描述
            // linkNow: window.location.origin + window.location.pathname + "codeFirm.html?parent_id=" + userInfo.id  //这个链接为，分享出去之后，用户访问的地址
        }
        console.log(shareData);

        shareData = Object.assign(normalConfig, shareData)
        WeixinShare['data'] = {
            title: shareData.shareName,
            desc: shareData.shareMs,
            link: shareData.linkNow,// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareData.shareImg,// 分享图标
        }
        
        console.log('28=>>WeixinShare.data',WeixinShare.data)

        wx.ready(function () {
            wx.updateAppMessageShareData(WeixinShare.data);
            //wx.onMenuShareQQ(Weixin.data);
            wx.updateTimelineShareData(WeixinShare.data);

        });
        //res.result.debug=true
        res.result.jsApiList = [

            'checkJsApi',
            'updateTimelineShareData',
            'updateAppMessageShareData',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onRecordEnd',
            'playVoice',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'

        ];
        // res.result.debug = true; // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        wx.config(res.result);
    },

}
